import { number, string } from 'prop-types';

const generalIncomeTypeBasicInformationPropTypes = {
  name: string.isRequired,
  expenseCode: number.isRequired,
  generalIncomeTypeLabel: string.isRequired,
  description: string,
};

export default generalIncomeTypeBasicInformationPropTypes;
